export const getParsedSessionStorageItem = <T>(key: string): T | null => {
    if (typeof window === 'undefined') return null;
    const item = window.sessionStorage.getItem(key);
    return item ? JSON.parse(item) : null;
};

export const setSessionStorageItem = (key: string, value: unknown): void => {
    if (typeof window === 'undefined') return;
    window.sessionStorage.setItem(key, JSON.stringify(value));
};
